import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import useBulkSelectColumnDefinition from "components/common/EntityDataTable/hooks/useBulkSelectColumnDefinition";
import { BULK_SELECT_COL_ID, ACTIONS_COL_ID } from "components/common/EntityDataTable/Constants";
import useActionsColumnDefinition from "components/common/EntityDataTable/hooks/useActionsColumnDefinition";
import useAttributeColumnDefinitions from "components/common/EntityDataTable/hooks/useAttributeColumnDefinitions";
const useColumnDefinitions = ({
  actionsColMinWidth,
  columnRenderersByAttribute,
  columnSchemas,
  columnWidths,
  displayBulkSelectCol,
  enableSlicing,
  entityActions,
  entityAttributesAreCamelCase,
  hasRowActions,
  meta,
  onActionsWidthChange,
  onChangeSlicing,
  onHeaderSectionResize,
  appSection
}) => {
  const columnHelper = createColumnHelper();
  const bulkSelectCol = useBulkSelectColumnDefinition(displayBulkSelectCol, columnWidths[BULK_SELECT_COL_ID]);
  const actionsTailCol = useActionsColumnDefinition({
    colWidth: columnWidths[ACTIONS_COL_ID],
    minWidth: actionsColMinWidth,
    entityActions,
    hasRowActions,
    onWidthChange: onActionsWidthChange
  });
  const attributeCols = useAttributeColumnDefinitions({
    columnHelper,
    columnRenderersByAttribute,
    columnSchemas,
    columnWidths,
    entityAttributesAreCamelCase,
    enableSlicing,
    meta,
    onChangeSlicing,
    onHeaderSectionResize,
    appSection
  });
  return useMemo(
    () => [...bulkSelectCol ? [bulkSelectCol] : [], ...attributeCols, actionsTailCol],
    [bulkSelectCol, attributeCols, actionsTailCol]
  );
};
export default useColumnDefinitions;
